import React, { useState } from 'react';
import { X, PhoneCall } from 'lucide-react';

export const InterventionModal = ({ conversation, agents, onClose, onSave }) => {
  const [selectedAgent, setSelectedAgent] = useState('');
  const [message, setMessage]             = useState('');

  const handleIntervention = async () => {
    const token = localStorage.getItem('admin_token');
    try {
      await fetch(`${window.location.origin}/api/chat/notify-staff`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: conversation.session_id, agent_id: selectedAgent, message })
      });
      alert('✅ TOUS les agents ont été notifiés par SMS !');
      onSave();
      onClose();
    } catch {
      alert('❌ Erreur lors de la notification');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl w-full max-w-2xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">📱 Notifier un Agent par SMS</h3>
          <button onClick={onClose}><X size={24} /></button>
        </div>
        <div className="space-y-4">
          <div className="bg-yellow-50 p-3 rounded">
            <p className="text-sm text-yellow-800">⚡ TOUS les agents seront notifiés en même temps par SMS</p>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Sélectionner un agent (optionnel)</label>
            <select value={selectedAgent} onChange={e => setSelectedAgent(e.target.value)}
              className="w-full border rounded-lg px-4 py-2">
              <option value="">Tous les agents</option>
              {Object.entries(agents).map(([id, agent]) => (
                <option key={id} value={id}>{agent.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2">Message pour l'agent</label>
            <textarea value={message} onChange={e => setMessage(e.target.value)}
              className="w-full border rounded-lg px-4 py-2 h-24"
              placeholder="Instructions supplémentaires..." />
          </div>
          <button onClick={handleIntervention}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-3 rounded-lg flex items-center justify-center space-x-2">
            <PhoneCall size={20} />
            <span>📱 Notifier par SMS</span>
          </button>
        </div>
      </div>
    </div>
  );
};
